import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/globals.css';

// Pages
import Home from './pages/Home';
import TeacherLogin from './pages/TeacherLogin';
import TeacherDashboard from './pages/TeacherDashboard';
import TeacherSessionManagement from './pages/TeacherSessionManagement';
import TeacherSessionLive from './pages/TeacherSessionLive';
import CreateQuestion from './pages/CreateQuestion';
import EditQuestion from './pages/EditQuestion';
import StudentJoin from './pages/StudentJoin';
import StudentSession from './pages/StudentSession';
import StudentAutonomousQuiz from './pages/StudentAutonomousQuiz';
import TestConnection from './pages/TestConnection';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/teacher/login" element={<TeacherLogin />} />
          <Route path="/teacher/dashboard" element={<TeacherDashboard />} />
          <Route path="/teacher/sessions/:sessionId" element={<TeacherSessionManagement />} />
          <Route path="/teacher/sessions/:sessionId/live" element={<TeacherSessionLive />} />
          <Route path="/teacher/sessions/:sessionId/questions/create" element={<CreateQuestion />} />
          <Route path="/teacher/sessions/:sessionId/questions/:questionId/edit" element={<EditQuestion />} />
          <Route path="/student/join" element={<StudentJoin />} />
          <Route path="/student/session/:sessionId" element={<StudentSession />} />
          <Route path="/quiz/:sessionCode" element={<StudentAutonomousQuiz />} />
          <Route path="/test" element={<TestConnection />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;